import { useEffect, useRef, useState } from "react";

export function useCanvas() {
  const canvasRef = useRef(null);
  const downloadRef = useRef(null);
  
  const [url, setUrl] = useState(null);
  // 1. Novo estado para a cor do texto (padrão claro)
  const [textColor, setTextColor] = useState("#ede8d3"); 

  const [message, setMessage] = useState(null);
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [image, setImage] = useState(null);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const [currentMessage, setMessageIndex] = useState(0);
  const [currentFrom, setFromIndex] = useState(0);
  const [currentTo, setToIndex] = useState(0);
  let call;
  let posX = 0;
  let posY = 0;

  // Seletores do DOM
  var groupFrom       = document.querySelector("#group-from");
  var groupTo         = document.querySelector("#group-to");
  var groupMessage    = document.querySelector("#group-message");
  var groupButtons    = document.querySelector(".group-buttons");
  var progressBar     = document.querySelector("#barra-proresso");
  var infoTitle       = document.querySelector(".info-title-cartao");
  var infoDescription = document.querySelector(".info-cartao");
  var alterStar       = document.querySelector(".div-star");


  function fetchUrl(){
    if (canvasRef !== null) {
      const canvas = canvasRef.current;
      const image = new Image();

      image.src = url;
      // console.log(url);

      image.onload = function () {
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext("2d").drawImage(image, 0, 0);
      };

      setImage(image);
    }
  }

  useEffect(() => {
    fetchUrl();
  }, [url]);

  function fetchMessage(){
    if (canvasRef !== null && message !== null) {  
      const canvas = canvasRef.current;

      if (url.match("cartao-cejam")) {
        posX = canvas.width * 0.1;
        posY = canvas.height / 2;
        message.forEach((msg, index) => {
          canvas.getContext("2d").font = `${canvas.width * 0.022}px Poppins`;
          canvas.getContext("2d").width = `${posX/2}`;
          canvas.getContext("2d").textAlign = "start";
          // USA A COR DINÂMICA
          canvas.getContext("2d").fillStyle = textColor; 
          canvas.getContext("2d").fillText(msg, posX - 30 , posY - 20 + index * 30);
        });
      } else {
        posX = canvas.width / 1.3;
        posY = canvas.height / 2;
        message.forEach((msg, index) => {
          canvas.getContext("2d").font = `${canvas.width * 0.022}px Poppins`;
          canvas.getContext("2d").width = `${posX/2}`;
          canvas.getContext("2d").textAlign = "start";
          // USA A COR DINÂMICA
          canvas.getContext("2d").fillStyle = textColor;                        
          canvas.getContext("2d").fillText(msg, posX/13, posY -20 + index * 30);
        });
      }
      const src = canvas.toDataURL("image/png");
      downloadRef.current.href = src;
      setMessageIndex(currentMessage + 1);
      groupFrom.classList.add("d-none");
      groupTo.classList.add("d-none");
      groupMessage.classList.add("d-none");
      groupButtons.classList.remove("d-none");
      progressBar.classList.remove('w-30');
      progressBar.classList.remove('w-60');
      progressBar.classList.add('w-100');
      alterStar.classList.remove('apagado');
      alterStar.classList.add('parabens');
      infoTitle.innerHTML = '<span class="text-gratulation">Parabéns!</span><br/>O seu cartão personalizado está pronto.';
      infoDescription.innerHTML = "Escolha se deseja fazer o download ou enviá-lo diretamente pelo WhatsApp."
    }
  }

  useEffect(() => {
    if(currentMessage >= 1 && !call){
      resetCanvas("fetchMessage");
      call = undefined;
    }
    fetchMessage();
  }, [message]);

  function fetchFrom(){
    if (canvasRef !== null) {
      const canvas = canvasRef.current;
      if (from !== "" && from !== null) {
        if (url.match("cartao-cejam")) {
          posX = canvas.width * 0.145 - 10;
          posY = canvas.height - 145;
        } else{
          posX = canvas.width * 0.14 - 10;
          posY = canvas.height - 143;
        } 

        canvas.getContext("2d").font = `${canvas.width * 0.025}px Poppins`;
        canvas.getContext("2d").textAlign = "left";
        // USA A COR DINÂMICA
        canvas.getContext("2d").fillStyle = textColor; 
        canvas.getContext("2d").fillText(from, posX, posY);

        const src = canvas.toDataURL("image/png");
        downloadRef.current.href = src;
        groupFrom.classList.add("disable");
        groupTo.classList.remove("d-none");
        progressBar.classList.add('w-30');
        infoTitle.innerHTML = "Ótimo! Faltam só mais alguns passos.";
        infoDescription.innerHTML = "Em “Para”, escreva o nome da pessoa especial que irá receber seu cartão. Clique em “OK” para confirmar."
      }
    }
    setFromIndex(currentFrom + 1);
  }

  useEffect(() => {
    if(currentFrom >= 1 && !call){
      resetCanvas("fetchFrom");
      call = undefined;
    }
    fetchFrom();
  }, [from]);

  function fetchTo(){
    if (canvasRef !== null) {
      const canvas = canvasRef.current;
      if (to !== "" && to !== null) {
        if (url.match("cartao-cejam")) {
          posX = canvas.width * 0.16;
          posY = canvas.height - 85;
        } else{
          posX = canvas.width * 0.16;
          posY = canvas.height - 85;
        } 

        canvas.getContext("2d").font = `${canvas.width * 0.025}px Poppins`;
        canvas.getContext("2d").textAlign = "left";
        // USA A COR DINÂMICA
        canvas.getContext("2d").fillStyle = textColor; 
        canvas.getContext("2d").fillText(to, posX, posY);
        
        const src = canvas.toDataURL("image/png");
        downloadRef.current.href = src;

        groupTo.classList.add("d-none");
        groupFrom.classList.add("d-none");
        groupMessage.classList.remove("d-none");
        progressBar.classList.remove('w-30');
        progressBar.classList.add('w-60');
        infoTitle.innerHTML = "Agora é hora de escolher sua mensagem preferida.";
        infoDescription.innerHTML = "Clique nas setas para visualizá-las. Depois, clique em cima da mensagem para selecioná-la."
      }
      
    }
    setToIndex(currentTo + 1);
  }

  useEffect(() => {
    if(currentTo >= 1 && !call){
      resetCanvas("fetchTo");
      call = undefined;
    }
    fetchTo();
  }, [to]);

  function resetCanvas(par) {
    call = par;
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    canvas.getContext("2d").drawImage(image, 0, 0);
    if(call == "fetchMessage"){
      fetchTo();
      fetchFrom();
    }else if(call == "fetchTo"){
      fetchMessage();
      fetchFrom();
    }else if(call == "fetchFrom"){
      fetchMessage();
      fetchTo();
    }
  }

  function voltarCartoes(e){
    restartCanvas();
    setTimeout(() => {
      setUrl();
    }, 100);
  }

  function restartCanvas() {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    canvas.getContext("2d").drawImage(image, 0, 0);

    setMessage(null);
    setFrom(null);
    setTo(null);
    fromRef.current.value = "";
    toRef.current.value = "";

    groupTo.classList.add("d-none");
    groupFrom.classList.remove("d-none");
    groupMessage.classList.add("d-none");
    groupButtons.classList.add("d-none");
    progressBar.classList.remove('w-100');
    alterStar.classList.remove('parabens');
    alterStar.classList.add('apagado');
    infoTitle.innerHTML = "Enviar o cartão do CEJAM é muito facil. Vamos lá? ";
    infoDescription.innerHTML = 'Comece preenchendo o campo "De" com o seu nome. Em seguida, clique em "OK".'
  }

  return {
    downloadRef,
    message,
    from,
    fromRef,
    to,
    toRef,
    url,
    setUrl,
    // Retornamos as novas propriedades para o componente usar
    textColor,
    setTextColor, 
    canvasRef,
    setMessage,
    setTo,
    setFrom,
    setMessageIndex,
    resetCanvas,
    voltarCartoes,
    restartCanvas,
  };
}
